import React from 'react';
import { Clear } from '@mui/icons-material';

import {
  Modal,
  Box,
  Paper,
  Typography,
  IconButton,
  Backdrop,
  Fade,
  useTheme,
  useMediaQuery,
  Theme,
} from '@mui/material';

import { CustomButton } from '@buttons/CustomButton';
import envelop from '@assets/images/Envelop.svg';

import { ZustandContext } from '@store/modalStore';
import { makeStyles } from '@mui/styles';

type UnRegisteredContributorModalProps = {
  onClose: () => void;
};
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
    top: '50%',
    left: '50%',
    width: 420,
    borderRadius: 8,
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
}));

export const UnRegisteredContributorModal: React.FC<
  UnRegisteredContributorModalProps
> = ({ onClose }) => {
  const classes = useStyles();
  const { breakpoints, palette } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('lg'));

  return (
    <Modal
      open
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in>
        <Paper className={classes.root} style={{ height: '390px' }}>
          <Box padding={2}>
            <Box
              display={'flex'}
              flexDirection={'row'}
              justifyContent={'center'}
              alignItems={'center'}
              textAlign="center"
              position={'relative'}
            >
              <Typography
                textAlign={'center'}
                fontSize={16}
                fontWeight={'bold'}
                marginLeft="5px"
                paddingTop="25px"
                marginBottom="20px"
              >
                Por el momento no ha sido posible localizar su registro y/o su
                número de colaborador, Te solicitamos, por favor, comunicarse al
                número telefónico:
              </Typography>
              <Box position={'absolute'} top={-5} right={0}>
                <IconButton onClick={onClose}>
                  <Clear />
                </IconButton>
              </Box>
            </Box>
            <Typography
              fontWeight={700}
              textAlign={'center'}
              fontSize={16}
              sx={{ color: '#1c6ad4' }}
            >
              55 8979 0980
            </Typography>

            <Typography fontWeight={700} textAlign={'center'} fontSize={16}>
              o a través del correo electrónico
            </Typography>
            <Box
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              <Box
                component={'img'}
                src={envelop}
                sx={{
                  width: 24,
                  height: 24,
                }}
                alt="Phone"
              />
              <CustomButton
                text="solicitudescoppel@inter.mx"
                onClick={() => null}
                size={isDesktop ? 'medium' : 'small'}
                variant={'text'}
                style={{
                  color: palette.primary.main,
                  fontSize: '14px',
                  textTransform: 'none',
                  textDecoration: 'underline',
                  marginBottom: '24px',
                  marginTop: '24px',
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
